import * as UI from "@iyk/ui"

import { Profile } from "../profile.ts"
import { AttributesList } from "./attributes-list.tsx"
import { Sheet } from "./sheet.tsx"

export const CollectionSheet = ({ collectable, ...props }: CollectionSheet.Props) => {
  return (
    <Sheet.Root {...props}>
      <Sheet.Content title={collectable.title} description={collectable.description}>
        <div className="flex flex-col gap-4 px-4 pt-10 pb-6">
          <div className="flex flex-col gap-2">
            <UI.Icon.Proof />
            <div className="flex flex-col gap-0.5">
              <span>{collectable.title}</span>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs-upper">Description</span>
            <span className="text-sm">{collectable.description}</span>
          </div>
          <AttributesList attributes={collectable.attributes} />

          {Profile.Collectable.$is("Item")(collectable) && collectable.url && (
            <a
              className={UI.classForButton({
                kind: "shaded",
                size: "lg",
                className: "w-full mt-4"
              })}
              href={collectable.url}
            >
              Buy now
              <UI.Icon.ArrowUpRight />
            </a>
          )}
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

namespace CollectionSheet {
  export type Props = {
    collectable: Profile.Collectable
    open: boolean
    onOpenChange: (value: boolean) => void
  }
}
